// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jyyd","question":"styles_question__dzRhL","inputVisibleButton":"styles_inputVisibleButton__1JeuA","note":"styles_note__1kGlt"};